import JswInteractiveBoardV0, { ModulePropsV0 } from './versions/v0';

// TODO: create a fn for this
// https://bitbucket.org/atlassian/jluong/src/spike/libraries/web-platform-sdk/src/utils.ts
type VersionSelectType = {
  readonly version: number;
  readonly fields: ModulePropsV0;
};

const versionSelect = ({ version, fields }: VersionSelectType) => {
  switch (version) {
    case 0:
      return <JswInteractiveBoardV0 {...fields} />;
    default:
      throw new Error('Unknown module version');
  }
};

export default versionSelect;
